import Paper from "@material-ui/core/Paper";
import MaterialTable from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import SaveIcon from "@material-ui/icons/Save";
import MapIcon from "@material-ui/icons/Map";
import { equipmentImage } from "assets/pics";
import Button from "components/shared/Button";
import EquipmentMap from "components/Map";
import Modal from "components/shared/Modal";
import Input from "components/shared/Input";
import ModalWindow from "components/shared/ModalWindow";
import { ResultsModal } from "components/shared/ResultsModal";
import Select from "components/shared/Select";
import { Table } from "components/shared/Table";
import ToolTip from "components/shared/ToolTip";
import { Formik } from "formik";
import React, { useEffect, useState } from "react";
import styles from "./styles.module.css";

const dateOptions = {
  day: "numeric",
  month: "short",
  year: "numeric",
};

export const Equipment = ({
  loadEquipment,
  loadMasters,
  equipment,
  addEquipment,
  deleteEquipment,
  editEquipment,
  isRequesting,
  masters,
  userRole,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [isResultsModalOpen, setIsResultsModalOpen] = useState(false);
  const [activeEquipment, setActiveEquipment] = useState("");
  const [initMapValues, setInitMapValues] = useState([
    30.3438983, 53.9078948, 9,
  ]);
  const [open, setOpen] = useState(false);

  const initialValues = {
    name: modalData?.name ?? "",
    photo: modalData?.photo ?? "",
    serialNum: modalData?.serialNum ?? "",
    machineId: modalData?.machineId ?? "",
    masterId: modalData?.master?.masterId ?? "",
    nextInspectionDate: modalData?.nextInspectionDate ?? "",
    weldingProcess: modalData?.weldingProcess ?? "",
    weldingMethod: modalData?.weldingMethod ?? "",
    noLoadVoltage: modalData?.noLoadVoltage ?? "",
    minCurrentValue: modalData?.minCurrentValue ?? "",
    maxCurrentValue: modalData?.maxCurrentValue ?? "",
    minVoltageValue: modalData?.minVoltageValue ?? "",
    maxVoltageValue: modalData?.maxVoltageValue ?? "",
    loadPercentage: modalData?.loadPercentage ?? "",
  };

  const formattedMasters = masters?.map((item) => {
    return {
      value: item.masterId,
      label: `${item.surname} ${item.name}`,
    };
  });

  useEffect(() => {
    loadEquipment();
    loadMasters();
  }, [loadEquipment, loadMasters]);

  const columns = [
    { title: "Наименование", field: "name" },
    { title: "RFID метка", field: "machineId" },
    {
      title: "Фото",
      field: "photo",
      render: (rowData) => (
        <img
          style={{
            width: 40,
            height: 40,
            borderRadius: "50%",
          }}
          src={
            rowData.photo ??
            "https://semantic-ui.com/images/wireframe/white-image.png"
          }
          alt=""
        />
      ),
    },
    { title: "Маркировка", field: "serialNum" },
    {
      title: "Процесс сварки",
      field: "weldingProcess",
      render: (rowData) => <p>{rowData.weldingProcess}</p>,
    },
    {
      title: "Способ сварки",
      field: "weldingMethod",
      render: (rowData) => <p>{rowData.weldingMethod}</p>,
    },
    {
      title: "Дата очередной аттестации (ППР)",
      field: "nextInspectionDate",
      type: "date",
      render: (rowData) => (
        <span>
          {new Date(rowData?.nextInspectionDate).toLocaleDateString(
            "ru-RU",
            dateOptions
          )}
        </span>
      ),
    },
    {
      title: "Закреплено",
      field: "masterId",
      render: (rowData) => {
        const master = masters.find(
          (item) => item.masterId === rowData?.master?.masterId
        );
        return (
          <p>
            {master?.surname} {master?.name} {master?.patronymic}
          </p>
        );
      },
    },
    {
      field: "link",
      title: "Отчет",
      render: (rowData) => (
        <div
          onClick={() => {
            setIsResultsModalOpen(true);
            setActiveEquipment(rowData?.machineId);
          }}
        >
          <SaveIcon />
        </div>
      ),
      width: 54,
    },
    {
      field: "link",
      title: "На карте",
      render: (rowData) => (
        <div
          onClick={() => {
            setInitMapValues([
              rowData?.geoData?.ing,
              rowData?.geoData?.lat,
              15,
            ]);
            handleOpen();
          }}
        >
          <MapIcon />
        </div>
      ),
      width: 54,
    },
  ];
  const requiredKeys = ["name", "nextInspectionDate"];

  const handleOpen = () => {
    setOpen(true);
  };

  const renderRowChildren = (rowData) => {
    return (
      rowData && (
        <TableContainer component={Paper}>
          <MaterialTable aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell
                  style={{
                    borderBottom: 0,
                  }}
                  align="center"
                >
                  Процесс сварки
                </TableCell>
                <TableCell
                  style={{
                    borderBottom: 0,
                  }}
                  align="center"
                >
                  Способ сварки
                </TableCell>
                <TableCell
                  style={{
                    borderBottom: 0,
                  }}
                  align="center"
                >
                  Напряжение холостого хода, В
                </TableCell>
                <TableCell
                  style={{
                    borderBottom: 0,
                  }}
                  align="center"
                  colSpan={2}
                >
                  Диапазон сварочного тока, А
                </TableCell>
                <TableCell
                  style={{
                    borderBottom: 0,
                  }}
                  align="center"
                  colSpan={2}
                >
                  Диапазон напряжения на дуге, В
                </TableCell>
                <TableCell
                  style={{
                    borderBottom: 0,
                  }}
                  align="center"
                >
                  Продолжительность включения/нагрузки, %
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell />
                <TableCell />
                <TableCell />
                <TableCell align="center">min</TableCell>
                <TableCell align="center">max</TableCell>
                <TableCell align="center">min</TableCell>
                <TableCell align="center">max</TableCell>
                <TableCell />
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell align="center" component="th" scope="row">
                  {rowData?.weldingProcess ?? "-"}
                </TableCell>
                <TableCell align="center" component="th" scope="row">
                  {rowData?.weldingMethod ?? "-"}
                </TableCell>
                <TableCell align="center" component="th" scope="row">
                  {rowData?.noLoadVoltage ?? "-"}
                </TableCell>
                <TableCell align="center">
                  {rowData?.minCurrentValue ?? "-"}
                </TableCell>
                <TableCell align="center">
                  {rowData?.maxCurrentValue ?? "-"}
                </TableCell>
                <TableCell align="center">
                  {rowData?.minVoltageValue ?? "-"}
                </TableCell>
                <TableCell align="center">
                  {rowData?.maxVoltageValue ?? "-"}
                </TableCell>
                <TableCell align="center" component="th" scope="row">
                  {rowData?.loadPercentage ?? "-"}
                </TableCell>
              </TableRow>
            </TableBody>
          </MaterialTable>
        </TableContainer>
      )
    );
  };

  return (
    <div className={styles.innerWrapper}>
      <ToolTip
        title="Оборудование"
        toolTipText="Здесь Вы можете просмотреть оборудование, его технические характеристики"
        src={equipmentImage}
        button={
          <button type="button" className={styles.button} onClick={handleOpen}>
            Оборудование на карте
          </button>
        }
      />
      {open ? (
        <Modal
          open={open}
          setOpen={() => {
            setOpen(false);
            setInitMapValues([30.3438983, 53.9078948, 9]);
          }}
          children={
            <EquipmentMap equipment={equipment} initMapValues={initMapValues} />
          }
        />
      ) : null}
      <div className={styles.tableWrapper}>
        <Table
          title="Оборудование"
          columns={columns}
          data={equipment}
          isLoading={isRequesting}
          actions={
            userRole === "admin"
              ? [
                  {
                    icon: "add",
                    tooltip: "Добавить оборудование",
                    isFreeAction: true,
                    onClick: () => setIsModalOpen(true),
                  },
                  {
                    icon: "edit",
                    tooltip: "Редактировать оборудование",
                    onClick: (event, rowData) => {
                      setModalData(rowData);
                      setIsModalOpen(true);
                    },
                  },
                ]
              : []
          }
          renderRowChildren={renderRowChildren}
          deleteAction={userRole === "admin" ? deleteEquipment : null}
        />
      </div>
      <ResultsModal
        type={"EQUIPMENT"}
        activeId={activeEquipment}
        isOpen={isResultsModalOpen}
        setIsOpen={setIsResultsModalOpen}
      />
      <ModalWindow
        isOpen={isModalOpen}
        headerText={
          modalData ? "Редактировать оборудование" : "Добавить оборудование"
        }
        setIsOpen={(state) => {
          setIsModalOpen(state);
          setModalData(null);
        }}
        wrapperStyles={{ width: 420 }}
      >
        <Formik
          initialValues={initialValues}
          enableReinitialize
          onSubmit={(variables) => {
            const { id, ...dataToSend } = variables;
            modalData
              ? editEquipment({ ...variables })
              : addEquipment({ ...dataToSend });
            setIsModalOpen(false);
            setModalData(null);
          }}
        >
          {({
            handleSubmit,
            handleChange,
            values,
            setFieldValue,
            handleBlur,
          }) => (
            <form onSubmit={handleSubmit}>
              <div className={styles.row}>
                <Input
                  onChange={(e) => {
                    handleChange(e);
                  }}
                  width="200"
                  style={{ height: 40, padding: "0 20px 0 30px" }}
                  value={values.name}
                  name="name"
                  placeholder="Наименовние"
                  onBlur={handleBlur}
                />
                <Input
                  onChange={(e) => {
                    handleChange(e);
                  }}
                  width="200"
                  style={{ height: 40, padding: "0 20px 0 30px" }}
                  value={values.serialNum}
                  name="serialNum"
                  placeholder="Маркировка"
                  onBlur={handleBlur}
                />
              </div>
              <div className={styles.row}>
                <Input
                  onChange={(e) => {
                    handleChange(e);
                  }}
                  style={{ height: 40, padding: "0 20px 0 30px", width: 380 }}
                  value={values.photo}
                  name="photo"
                  placeholder="Фото"
                  onBlur={handleBlur}
                />
              </div>
              <div className={styles.row}>
                <Input
                  onChange={(e) => {
                    handleChange(e);
                  }}
                  width="200"
                  style={{ height: 40, padding: "0 20px 0 30px" }}
                  value={values.nextInspectionDate}
                  name="nextInspectionDate"
                  placeholder="Дата инспекции"
                  type="text"
                  onFocus={(e) => {
                    e.currentTarget.type = "date";
                  }}
                  onBlur={handleBlur}
                />
                <Select
                  name="masterId"
                  value={values.masterId}
                  width="186px"
                  placeholder="Мастер"
                  onChange={(e) => {
                    setFieldValue("masterId", e.value);
                  }}
                  options={formattedMasters}
                />
              </div>
              <p className={styles.text}>Режим работы</p>
              <div className={styles.row}>
                <Input
                  onChange={(e) => {
                    handleChange(e);
                  }}
                  style={{
                    width: 180,
                    height: 40,
                    paddingLeft: 20,
                  }}
                  value={values.weldingProcess}
                  name={`weldingProcess`}
                  placeholder="Процесс сварки"
                />
                <Input
                  onChange={(e) => {
                    handleChange(e);
                  }}
                  style={{
                    width: 180,
                    height: 40,
                    paddingLeft: 20,
                  }}
                  value={values.weldingMethod}
                  name={`weldingMethod`}
                  placeholder="Способ сварки"
                />
              </div>
              <div className={styles.row}>
                <Input
                  onChange={(e) => {
                    handleChange(e);
                  }}
                  style={{
                    width: 380,
                    height: 40,
                    paddingLeft: 20,
                  }}
                  value={values.noLoadVoltage}
                  name={`noLoadVoltage`}
                  placeholder="Напряжение холостого хода"
                />
              </div>
              <div className={styles.row}>
                <Input
                  onChange={(e) => {
                    handleChange(e);
                  }}
                  style={{
                    width: 380,
                    height: 40,
                    paddingLeft: 20,
                  }}
                  value={values.loadPercentage}
                  name={`loadPercentage`}
                  placeholder="Продолжительность нагрузки, %"
                />
              </div>
              <p className={styles.text}>Диапазон сварочного тока:</p>
              <div className={styles.row}>
                <Input
                  onChange={(e) => {
                    handleChange(e);
                  }}
                  style={{
                    width: 180,
                    height: 40,
                    paddingLeft: 20,
                  }}
                  value={values.minCurrentValue}
                  name={`minCurrentValue`}
                  placeholder="min"
                  onBlur={handleBlur}
                />
                <Input
                  onChange={(e) => {
                    handleChange(e);
                  }}
                  style={{
                    width: 180,
                    height: 40,
                    paddingLeft: 20,
                  }}
                  value={values.maxCurrentValue}
                  name={`maxCurrentValue`}
                  placeholder="max"
                />
              </div>
              <p className={styles.text}>Диапазон напряжения на дуге:</p>
              <div className={styles.row}>
                <Input
                  onChange={(e) => {
                    handleChange(e);
                  }}
                  style={{
                    width: 180,
                    height: 40,
                    paddingLeft: 20,
                  }}
                  value={values.minVoltageValue}
                  name={`minVoltageValue`}
                  placeholder="min"
                />
                <Input
                  onChange={(e) => {
                    handleChange(e);
                  }}
                  style={{
                    width: 180,
                    height: 40,
                    paddingLeft: 20,
                  }}
                  value={values.maxVoltageValue}
                  name={`maxVoltageValue`}
                  placeholder="max"
                />
              </div>
              {!modalData && (
                <div className={styles.row}>
                  <Input
                    onChange={(e) => {
                      handleChange(e);
                    }}
                    style={{
                      width: 380,
                      height: 40,
                    }}
                    value={values.machineId}
                    name={`machineId`}
                    placeholder="RFID метка"
                  />
                </div>
              )}
              <div className={styles.row}>
                <Button
                  disabled={requiredKeys.some((key) => !values[key])}
                  type="submit"
                >
                  {modalData ? "Сохранить" : "Создать"}
                </Button>
              </div>
            </form>
          )}
        </Formik>
      </ModalWindow>
    </div>
  );
};
